export default {
  feedback: {
    token_required: 'Bitte klicke das Kontrollkästchen, um zu bestätigen, dass du ein Mensch bist',
  },
};
